var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { colors } from '../../styles/colors';
export var typographyWeights = {
    regular: 400,
    semibold: 600,
    bold: 700,
};
export var typographyLineHeight = {
    small: 16,
    body: 20,
    h1: 32,
    h2: 28,
    h3: 24,
};
var body = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: ", ";\n  letter-spacing: 0.15px;\n  line-height: ", "px;\n"], ["\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: ", ";\n  letter-spacing: 0.15px;\n  line-height: ", "px;\n"])), typographyWeights.regular, typographyLineHeight.body);
var h1 = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: inherit;\n  font-size: 24px;\n  font-weight: ", ";\n  letter-spacing: 0.15px;\n  line-height: ", "px;\n"], ["\n  font-family: inherit;\n  font-size: 24px;\n  font-weight: ", ";\n  letter-spacing: 0.15px;\n  line-height: ", "px;\n"])), typographyWeights.bold, typographyLineHeight.h1);
var h2 = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: inherit;\n  font-size: 20px;\n  font-weight: ", ";\n  letter-spacing: 0.15px;\n  line-height: ", "px;\n"], ["\n  font-family: inherit;\n  font-size: 20px;\n  font-weight: ", ";\n  letter-spacing: 0.15px;\n  line-height: ", "px;\n"])), typographyWeights.semibold, typographyLineHeight.h2);
var h3 = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: ", ";\n  letter-spacing: 0.15px;\n  line-height: ", "px;\n"], ["\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: ", ";\n  letter-spacing: 0.15px;\n  line-height: ", "px;\n"])), typographyWeights.semibold, typographyLineHeight.h3);
var small = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 0.25px;\n  line-height: ", "px;\n"], ["\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 0.25px;\n  line-height: ", "px;\n"])), typographyWeights.regular, typographyLineHeight.small);
var typographyIntents = {
    body: body,
    h1: h1,
    h2: h2,
    h3: h3,
    small: small,
};
export function getTypographyIntent(intent) {
    return typographyIntents[intent];
}
export var StyledTypography = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n\n  em,\n  i {\n    font-style: italic;\n  }\n"], ["\n  ", "\n  color: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n\n  em,\n  i {\n    font-style: italic;\n  }\n"])), function (_a) {
    var _b = _a.intent, intent = _b === void 0 ? 'body' : _b;
    return typographyIntents[intent];
}, function (_a) {
    var _b = _a.$color, $color = _b === void 0 ? 'gray15' : _b;
    return colors[$color];
}, function (_a) {
    var _b = _a.italic, italic = _b === void 0 ? false : _b;
    return (italic ? 'italic' : 'inherit');
}, function (_a) {
    var weight = _a.weight;
    return weight && typographyWeights[weight];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Typography.styles.js.map